import React, { Component } from 'react';
import styled from 'styled-components';
import {
  Title,
  Text,
  Input,
  Column,
  Row,
  Button,
  Label,
  UserWarn,
} from '../../theme/index';
import { Formik } from 'formik';
import { userLogin, USER_LOGIN_SUCCESS } from './redux/actions';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

const Wrapper = styled.div`
  width: 450px;
  height: 365px;
  background: #fff;
  margin-top: 12em;
  position: relative;
  border-radius: 6px;
  @media (max-width: 400px) {
    width: 325px;
  }
  @media (max-width: 320px) {
    width: 315px;
    margin-top: 8em;
  }
`;

const Form = styled.form`
  width: 100%;
`;

const StyledColumn = styled(Column)`
  width: 85%;
  margin: 0 auto;
  @media (max-width: 400px) {
    width: 90%;
  }
`;

class LoginForm extends Component {
  render() {
    return (
      <Wrapper>
        <Title margin=".5em 0 .5em .75em">Login</Title>
        <Formik
          initialValues={{ email: '', password: '' }}
          validate={values => {
            let errors = {};

            if (!values.email) {
              errors.email = 'An email is required';
            }

            if (!values.password) {
              errors.password = 'A password is required';
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting, setErrors }) => {
            if (this.props.checkoutlink) {
              this.props
                .userLogin(values)
                .then(action => {
                  if (action.type === USER_LOGIN_SUCCESS) {
                    localStorage.setItem('authorization', action.authToken);
                    localStorage.setItem(
                      'appUser',
                      JSON.stringify(action.appUser)
                    );
                    window.location.href = `https://achievece.thinkific.com/api/sso/v2/sso/jwt?jwt=${
                      action.authToken
                    }&return_to=${this.props.checkoutlink}`;
                  } else {
                    setSubmitting(false);
                    setErrors({ login: 'Email or password is incorrect' });
                  }
                })
                .catch(err => {
                  setSubmitting(false);
                  setErrors({ login: 'Email or password is incorrect' });
                });
            } else {
              this.props
                .userLogin(values)
                .then(action => {
                  if (action.type === USER_LOGIN_SUCCESS) {
                    localStorage.setItem('authorization', action.authToken);
                    localStorage.setItem(
                      'appUser',
                      JSON.stringify(action.appUser)
                    );

                    window.location.href = `https://achievece.thinkific.com/api/sso/v2/sso/jwt?jwt=${
                      action.authToken
                    }&return_to=https://learn.achievece.com/enrollments`;
                  } else {
                    setSubmitting(false);
                    setErrors({ login: 'Email or password is incorrect' });
                  }
                })
                .catch(err => {
                  setSubmitting(false);
                  setErrors({ login: 'Email or password is incorrect' });
                });
            }
          }}
          render={({
            values,
            handleSubmit,
            handleBlur,
            handleChange,
            errors,
            touched,
          }) => (
            <Form onSubmit={handleSubmit}>
              <StyledColumn>
                <Row
                  alignitems="center"
                  style={{ position: 'relative', zIndex: 500 }}
                >
                  {errors.login && errors.login && (
                    <Text error>{errors.login}</Text>
                  )}
                </Row>
                <Row
                  alignitems="center"
                  style={{ position: 'relative', zIndex: 500 }}
                >
                  <Label htmlFor="email">
                    Email *
                    {touched.email && errors.email && (
                      <UserWarn>
                        <Text error>{errors.email}</Text>
                      </UserWarn>
                    )}
                    <Input
                      id="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      login
                    />
                  </Label>
                </Row>
                <Row
                  alignitems="center"
                  style={{ position: 'relative', zIndex: 500 }}
                >
                  <Label htmlFor="password">
                    Password *
                    {touched.password && errors.password && (
                      <UserWarn>
                        <Text error>{errors.password}</Text>
                      </UserWarn>
                    )}
                    <Input
                      type="password"
                      id="password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                      login
                    />
                  </Label>
                </Row>
                <Row
                  justifycontent="space-between"
                  alignitems="center"
                  margin="1.5em 0"
                >
                  <Link to="/forgot/password">
                    <Label>Forgot password?</Label>
                  </Link>
                  <Link to="/signup">
                    <Label loginButton>Create an account</Label>
                  </Link>
                </Row>
                <Button login type="submit">
                  Login
                </Button>
              </StyledColumn>
            </Form>
          )}
        />
      </Wrapper>
    );
  }
}

export default withRouter(
  connect(
    null,
    { userLogin }
  )(LoginForm)
);



// WEBPACK FOOTER //
// ./src/components/screens/Login/LoginForm.jsx